<template>
  <div class="image-card"
    :class="{
      loading: !mounted
    }"
    :style="{
      minHeight: mounted && 'unset'
    }"
   >
    <div 
      class="vogue-image-card" 
      :class="[type, 
      { 
        fixation: image_style == 'fixation',
        'card-effect__none':is_flash && is_flash == true
      },
      themeStyleRadius == 'circle' ? 'image-radius' : ''
      ]">
      <a class="vogue-card" :href="(list && list.url) || (list.button && list.button.url)" style="width:100%;height:100%;display:block;">
        <div class="collections-image" style="width:100%">
          <v-lazy-img 
            :src="image.thumbnail"
            :data-url="image.url"
            @load="handleImgLoad" 
            @error="handleImgError">
          </v-lazy-img>
        </div>
        <div
          v-if="list.button || type == 'six_blend_mb' || type == 'six_blend'"
          class="text text-fixed d-none d-md-block"
          :class="[blendStyle.align, {
            'd-block': type == 'grid',
            'd-block text-fixed-50': type == 'six_blend_mb',
            'text-fixed-50': type == 'six_blend',
          }]"
          :style="{ color: list.text_color ? list.text_color : '#fff' }"
        >
          <h5 v-if="list.title" :class="button_class + '_text'" class="title_font" :style="{fontSize: blendStyle.titleSize+'px'}">{{ list.title }}</h5>
          <p v-if="list.description" :class="button_class + '_text'" class="page_text_font" :style="{fontSize: blendStyle.textSize+'px'}">{{ list.description }}</p>
          <a
            v-if="
              list.button &&
              list.button.url &&
              list.button.text &&
              type != 'six_blend_mb'
            "
            class="vogue-home-btn  secondary_title"
            :class="[button_class,{
              'transition-bg-color': theme !=='default'
            },themeStyleRadius == 'circle' ? 'button-radius' : '']"
            :href="list.button.url"
          >{{ list.button.text }}</a>
        </div>
        <div class="mask" v-if="mask_opacity" :style="{ opacity: mask_opacity }"></div>
      </a>
    </div>
    <div
      v-if="
        ((list.button && list.button.text && list.button.url) ||
          list.title ||
          list.description) &&
        type != 'six_blend_mb' &&
        type != 'grid'
      "
      class="text d-md-none d-block"
      :class="[blendStyle.align]"
    >
      <h5 v-if="list.title" :class="button_class + '_text'" class="title_font" :style="{fontSize: blendStyle.titleSize+'px'}">{{ list.title }}</h5>
      <p v-if="list.description" :class="button_class + '_text'" class="page_text_font" :style="{fontSize: blendStyle.textSize+'px'}">{{ list.description }}</p>
      <a
        v-if="list.button && list.button.url"
        class="vogue-home-btn  secondary_title"
        :class="[button_class,{
          'transition-bg-color': theme !=='default'
        },themeStyleRadius == 'circle' ? 'button-radius' : '']"
        :href="list.button.url"
      >{{ list.button.text }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: [
    "list",
    "mask_opacity",
    "text_align",
    "type",
    "button_class",
    "image_style",
    "is_flash",
    "theme",
    "modelKey"
  ],
  emits: ['load', 'error'],
  data() {
    return {
      mounted: false
    }
  },
  methods: {
    handleImgLoad() {
      this.mounted = true
      this.$emit('load')
    },
    handleImgError() {
      this.mounted = true
      this.$emit('error')
    }
  },
  computed: {
    ...mapState({
      imageTextConfig({options}) {
        return options?.theme?.pages?.homepage[this.modelKey] || {}
      },
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
      isMobile: ({ isMobile }) => isMobile
    }),
    blendStyle(){
      let style = {}
      let align = ''
      if( this.imageTextConfig.layout_type == 'six_blend' ){
         align =  this.imageTextConfig.six_blend_config.align 
         style.titleSize = this.imageTextConfig.six_blend_config.title_size
         style.textSize = this.imageTextConfig.six_blend_config.text_size
      }else {
         align =  this.text_align
         style.titleSize = this.imageTextConfig.title_size
         style.textSize = this.imageTextConfig.text_size
      }
      switch (align) {
        case 'center':
          style.align = 'text-center'
          break;
        case 'left':
          style.align = 'text-left'
          break;
        case 'right':
          style.align = 'text-right'
          break;
        case 'bottom_center':
          style.align = 'text-bottom-center'
          break;
        case 'bottom_left':
          style.align = 'text-bottom-left'
          break;
        case 'bottom_right':
          style.align = 'text-bottom-right'
          break;
      }
      return style
    },
    /**
     * 显示的图片
     * pc图片
     * 移动端图片，没有的话显示pc图片
     */
    image() {
      const image = this.list?.image || {};
      const mbImg = this.list?.mobile_image?.url || this.list?.mb_image?.url ?  this.list?.mb_image || this.list?.mobile_image : image;

      if (this.isMobile) {
        return mbImg
      }

      return image
    }
  }
};
</script>

<style lang="scss" scoped>
.vogue-home-btn {
  letter-spacing: 1px;
  padding-left: 28px;
  margin: 16px 0;
  padding-right: 28px;
}
.image-card {
  // padding: 5px;
  .text {
    width: 100%;
    padding: 20px;

    color: #fff;
    font-size: 16px;

    h5 {
      font-size: 24px;
      margin:20px 0;
    }
    p {
      margin: 20px 0;
    }

    a {
      color: #fff;
    }
  }
  .text-right, .text-bottom-right {
    text-align: right;
  }
  .text-bottom-left, .text-bottom-center, .text-bottom-right {
    top: auto !important;
    transform: translate(0, 0) !important;
    bottom: 0 !important;
  }
  .text-bottom-center {
    text-align: center;
  }
  .fixation {
    .vogue-card {
      .collections-image {
        & > img {
          height: 550px !important;
          object-fit: cover;
        }
      }
    }
  }
  .six_blend_mb {
    .collections-image {
      padding-top: 100%;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        backface-visibility: hidden;
      }
    }
  }
  .card-effect__none {
    .collections-image {
      transition: unset !important;
    }
    &:hover {
      .collections-image {
        transform: unset !important;
      }
    }
  }
  .vogue-image-card {
    position: relative;
    overflow: hidden;
    .collections-image {
      transition: transform 8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        -webkit-transform 8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      img {
        width: 100% !important;
      }
    }
    &:hover {
      .collections-image {
        transform: scale(1.2);
      }
    }

    .text-fixed {
      position: absolute;
      //top: 70%;
      top: 50%;
      z-index: 10;
      transform: translate(0, -50%);
    }
    .text-fixed-50 {
      position: absolute;
      top: 50%;
      bottom: unset;
      transform: translateY(-50%);
    }

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      z-index: 5;
    }
  }
}
@media (max-width: 767px) {
  .image-card {
    padding: 0 !important;
    .text {
      h5 {
        font-size: 18px !important;
      }
      p {
        font-size: 14px !important;
      }
    }
    .six_blend_mb {
      .text-fixed{
        padding: 10px !important;
        h5{
          margin: 0 0 10px 0 !important;
        }
        p{
          margin: 10px 0 0 0 !important;
        }
      }
    }
  }
}
@media screen and (min-width: 1240px) {
  .image-card {
    .fixation {
      .vogue-card {
        .collections-image {
          & > img {
            height: 700px !important;
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>
